import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Funciona si tengo más de 50 años?',
    a: '¡Absolutamente! Nuestros resultados más impresionantes son de mujeres de 45-55 años.'
  }, {
    q: '¿Necesito ingredientes especiales o costosos?',
    a: 'No. La base del protocolo se arma con ingredientes de supermercado: huevos, carnes/pescado accesibles, verduras de estación, legumbres, arroz/quinoa según fase, yogur natural y semillas. Además, incluimos una Guía de Compras Argentina (versión económica + sustituciones) para que lo adaptes a tu presupuesto.'
  }, {
    q: '¿Tengo que hacer ejercicio extremo?',
    a: 'Solo 15-25 minutos de ejercicios restaurativos. Nada de gym ni equipos costosos.'
  }, {
    q: '¿Qué pasa si no veo resultados?',
    a: 'Garantía de 30 días. Si H.E.R. no es para vos, te devolvemos el 100% de tu dinero.'
  }, {
    q: '¿Funciona si estoy en menopausia?',
    a: 'Especialmente efectivo durante pre/menopausia. Está diseñado para esta etapa.'
  }, {
    q: '¿Es seguro si tengo condiciones médicas?',
    a: 'Es un protocolo natural, pero siempre consulta con tu médico primero.'
  }];
  return <section className="bg-gradient-hero py-12 md:py-16 px-4 md:px-8" data-id="element-84" data-mp="25hf9hi1wx5xd">
      <div className="max-w-3xl mx-auto space-y-12" data-id="element-85" data-mp="20nb2iysncxwa">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-4" data-id="element-86" data-mp="2fcpca804xhc7">
          <h2 className="text-4xl md:text-5xl font-display font-black" data-id="element-87" data-mp="2od5cn8ll08cu">
            Preguntas <span className="text-gradient-gold" data-id="element-88" data-mp="2jf3ucpvzcd2f">Frecuentes</span>
          </h2>
        </motion.div>

        {/* Accordions */}
        <div className="space-y-4" data-id="element-89" data-mp="u0xku44k47la">
          {faqs.map((faq, i) => <FAQItem key={i} faq={faq} index={i} data-id="element-90" data-mp="p1uf0hgr5xc9" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  faq,
  index
}: {
  faq: {
    q: string;
    a: string;
  };
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: index * 0.1
  }} className="card-premium overflow-hidden" data-id="element-91" data-mp="2u2x4g32jc0y0">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 md:p-6 text-left hover:bg-white/[0.02] transition-colors" data-id="element-92" data-mp="382pr9naxxx0p">
        <span className="font-body font-semibold text-base md:text-lg text-foreground flex items-start md:items-center gap-3 leading-snug" data-id="element-93" data-mp="3czg7qbqnqumn">
          <span className="text-xl mt-0.5 md:mt-0" data-id="element-94" data-mp="3mrucldd18hd1">❓</span> {faq.q}
        </span>
        <span className="text-secondary flex-shrink-0 ml-4" data-id="element-95" data-mp="3qsxsu0yzsfes">
          {isOpen ? <MinusIcon className="w-6 h-6" data-id="element-96" data-mp="3quqype1s6vlq" /> : <PlusIcon className="w-6 h-6" data-id="element-97" data-mp="3vrr5xsada4ef" />}
        </span>
      </button>

      <AnimatePresence data-id="element-98" data-mp="3vpy02f7kvo7h">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-99" data-mp="1k56up39xifme">
            <div className="px-5 md:px-6 pb-6 pt-2 text-foreground/80 font-body text-[15px] md:text-base font-medium flex items-start gap-3 border-t border-border/50 mt-2 leading-relaxed" data-id="element-100" data-mp="1b4ioguqs1jk2">
              <span className="text-xl mt-1" data-id="element-101" data-mp="22un8gsamk4kr">✅</span>
              <p className="pt-1" data-id="element-102" data-mp="1yttm43ctyxtz">{faq.a}</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}